import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import { useFrozenSupplierTabBreadcrumbs } from "Helpers/useFrozenSupplierBreadcrumbs";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as Vendor  } from "assets/SideBarIcons/vendor.svg";
import SupplierTabs from "./SupplierTabs";
import { Box } from "@mui/material";
import PurchaseOrderListing from "pages/Inventory/PurchaseOrderListing";
export default function SupplierPurchaseOrders() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const params = useParams();
    const breadcrumbItems = useFrozenSupplierTabBreadcrumbs("Purchase Orders");
    return (<>
        <ComponentHeaderTwo
            showBtn={true}
            showSaveBtn={false}
            onClick={() => navigate('/suppliers')}
            onSubmit={() => {}}
            heading={t('vendor')}
            icon={<Vendor height={28} width={28} />}
            btnText={"back"}
            btnType={"back"}
            showCreateBtn={false}
            breadcrumbItems={breadcrumbItems}
        />
        <Box className={`flex`}>
            <SupplierTabs params={params} selectedIndex={1} />
            <Box className='mt-[10px] w-[100%]'>
                <PurchaseOrderListing supplierId={+(params as any)?.id} />
            </Box>
        </Box>
    </>)
}
